import { useI18n } from "../i18n/I18nContext";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { PageHero, FeatureCard, CtaBlock } from "../components/Shared";

const HERO_IMG =
  "https://images.pexels.com/photos/18471441/pexels-photo-18471441.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";

export default function Business() {
  const { t } = useI18n();
  return (
    <>
      <PageHero
        overline={t.business.overline}
        title={t.business.title}
        desc={t.business.desc}
        image={t.business.heroImage || HERO_IMG}
      />

      <section className="bg-midnight border-t border-white/5">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
          <Reveal>
            <div className="overline mb-6">PROGRAM · 项目</div>
            <h2 className="font-display font-extrabold tracking-tighter text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.05] max-w-3xl uppercase">
              Что входит в benchmark-программу
            </h2>
          </Reveal>
          <Stagger className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
            {t.business.blocks.map((b, idx) => (
              <StaggerItem key={idx} className="bg-midnight-2">
                <FeatureCard title={b.t} desc={b.d} index={idx + 1} />
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="bg-[#0E1117]">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
          <Reveal>
            <div className="overline mb-6">COMPANIES · 公司</div>
            <h2 className="font-display font-extrabold tracking-tighter text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.05] max-w-3xl uppercase">
              {t.business.examplesTitle}
            </h2>
          </Reveal>
          <Stagger className="mt-12 flex flex-wrap gap-3">
            {t.business.examples.map((e) => (
              <StaggerItem
                key={e}
                data-testid={`business-example-${e}`}
                className="border border-white/15 px-5 py-3 font-display font-semibold text-white hover:border-coral hover:text-coral hover:bg-midnight-2 transition-all cursor-default"
              >
                {e}
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <CtaBlock title={t.business.cta} buttonText={t.nav.cta} />
    </>
  );
}
